<template>
  <van-swipe :autoplay="prop.autoplay">
    <van-swipe-item v-for="(item, index) in images" :key="index">
      <img v-lazy="valueKey?item[valueKey]:item" :style="{'height': prop.height,'width':'100%'}" @click="jump(item,index)"/>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
  import { getHdongUrl } from '../api/third'
  import { doItemCpsUrl, DuoduoRouter } from '../api/home'
export default {
  props: {
    valueKey: '',
    prop: {
      type: Object,
      default () {
        return {
          // autoplay: false,
          duration: 1000,
          height: '3.9rem'
        }
      }
    },
    images: Array
  },
  data () {
    return {
      imgs: [],
      height: ''
    }
  },
  created () {

  },
  watch: {
    images (val) {
      if (this.valueKey) {
        this.imgs = []
        for (let i = 0; i < this.images.length; i++) {
          this.imgs.push(this.images[i][this.valueKey])
        }
      } else {
        this.imgs = val
      }
    }
  },
  methods: {
    preview () {
      if (this.valueKey) {
        for (let i = 0; i < this.images.length; i++) {

        }
      }
    },
    jump (obj, i) {
      if (!this.valueKey) {
        this.previewImg(this.imgs, i)
      }
      // 淘宝ID，6
      // 京东ID，7
      // 拼多多ID，8
      if (obj.category === '1' && obj.url) {
        this.$router.push({path: '/rule', query: {url: obj.url, title: '资讯信息'}})
      } else if (obj.category === '2' && obj.productId) {
        this.$router.push({path: '/goodDetail', query: {type: '1', productId: obj.productId}})
      } else if (obj.category === '3') {
        this.$router.push({path: '/shop', query: {shopId: obj.storeId}})
      } else if (obj.category === '4'&& obj.thirdLink) {
        window.location.href = obj.thirdLink
      } else if (obj.category === '5' && obj.productCategoryId) {
        let temp = new Date().getTime()
        this.$router.push({path: '/List', query: {id: obj.productCategoryId, type: 'yd', title: obj.productCategoryName, temp: temp}})
      } else if (obj.category === '6' && obj.thirdLink) {
        // 折淘客获取活动api：如饿了么、轮播图选择淘宝id
        let data = {
          uid: localStorage.getItem('uid'),
          promotion_scene_id: '20150318019998255'
        }
        getHdongUrl(data).then(res =>{
          if (res.result === '0') {
            if(res.status === '0'){
              window.location.href = res.hDongUrl
            }else {
              // 获取淘宝渠道id
              if (this.isWx()) {
                this.$dialog.alert({
                  title: '提示',
                  message: '您是首次使用我惠省钱平台，为保证您的权益，请你点击右上角的“...”,选择“在浏览器中打开”进行下单。',
                  confirmButtonColor: this.m_color
                }).then(() => {
                })
              } else {
                let backurl = window.g.BeforeURL
                window.location.href = window.g.toBind + backurl
              }
            }
          }else {
            this.showToast(res.resultNote)
          }

        })

      }else if (obj.category === '7' && obj.thirdLink) {

        let data={
          uid: localStorage.getItem('uid'),
          materialId: obj.thirdLink,
          couponUrl:''
        }
        doItemCpsUrl(data).then(res =>{
          if(res.result==='0'){
            window.location.href = res.data.shortURL
          }
        })

      }else if (obj.category === '8' && obj.thirdLink) {

        let data={
          uid: localStorage.getItem('uid'),
          resource_type: '39998',
          url: obj.thirdLink
        }
        DuoduoRouter(data).then(res =>{
          if(res.result==='0'){
            window.location.href = res.data.resource_url_response.single_url_list.short_url
          }
        })

      }

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/swiper.vue